import cx from 'classnames';
import { SecondaryButton } from '~/components/common/Button';
import Chevron from '~/icons/Chevron';
import useViewDetailsButton from './useViewDetailsButton';

export default function ViewDetailsButton() {
  const { shouldShow, handleClick } = useViewDetailsButton();

  return (
    <div
      data-qa="view-details-button"
      className={cx(
        'w-[250px] self-center',
        shouldShow ? 'visible' : 'invisible'
      )}
    >
      <SecondaryButton
        className="group/view-button mt-4xl w-full bg-white"
        data-analytics-id="Key Features - Details"
        onClick={handleClick}
      >
        view details
        <Chevron className="group-hover/view-button:stroke-white" />
      </SecondaryButton>
    </div>
  );
}
